import compose from 'lodash/fp/compose';
import defaultReduce from 'lodash/reduce';
import defaultConcat from 'lodash/concat';

const betterConcat = (iterable, ...elements) => defaultConcat(iterable, elements);

export const abstract = {
  transduce: (reduce, concat, transducer, iterable, initial) =>
    reduce(transducer(concat), iterable, initial),

  reduce: processor => () => processor,

  filter: predicate => concat => (iterable, element) =>
    predicate(element) ? concat(iterable, element) : iterable,

  map: mapper => concat => (iterable, element) => concat(iterable, mapper(element)),

  withElementAt: (newElementIndex, newElement) => concat => (iterable, element, currentIndex) =>
    currentIndex === newElementIndex
      ? concat(iterable, newElement, element)
      : concat(iterable, element),
};

export const implment = (reduce, concat, defaultInitial) => ({
  ...abstract,
  compute: (...transducers) => (iterable, initial = defaultInitial) =>
    abstract.transduce(reduce, concat, compose(...transducers), iterable, initial),
});

export const array = implment(defaultReduce, betterConcat, []);

export const option = (key, param) => 
 Number.isNaN(param) || param === undefined ? {} : { [key]: param }; 

export const optionIf = (predicate, key, param) =>
  predicate ? option(key, param) : {};



// WEBPACK FOOTER //
// ./src/helpers/stdlib.js